import IPurchase_Order from "../../../../models/IPurchase_Order";
import PurchaseOrderStateEnum from "../../../../models/PurchaseOrderStateEnum";
import OwLabel from "../../../shared/OwLabel/OwLabel";
import { ControlBar } from "../../../shared/ControlBar/ControlBar";
import { IOtherPurchaseOrderButtonsCallbacks } from "./IOtherPurchaseOrderButtonsCallbacks";
import { Dropdown } from "react-bootstrap";

type Props = {
    purchaseOrder?: IPurchase_Order;
    qboActive: boolean;
    isAdminUser: boolean;
    hasQbo: boolean;
    callbacks: IOtherPurchaseOrderButtonsCallbacks;
};

export const OtherPurchaseOrderButtons = (props: Props) => {
    const showQboSection =
        props.isAdminUser &&
        props.hasQbo &&
        (props.purchaseOrder?.po_state_id !== PurchaseOrderStateEnum.PRELIMINARY || !!props.purchaseOrder?.qbo_PurchaseOrderId);

    if (!showQboSection) {
        return null;
    }

    const qboDropdown = (
        <Dropdown data-bs-theme="dark">
            <Dropdown.Toggle size="sm" variant="primary" disabled={props.qboActive}>
                <i className="fad fa-books me-2" />
                <OwLabel title={"quickbooks_online"} />
            </Dropdown.Toggle>
            <Dropdown.Menu>
                {props.purchaseOrder?.qbo_PurchaseOrderId ? (
                    <>
                        <Dropdown.Item onClick={props.callbacks.viewQboPurchaseOrder} disabled={props.qboActive}>
                            <OwLabel title={"view_purchase_order"} />
                        </Dropdown.Item>
                        <Dropdown.Item onClick={props.callbacks.emailQboPurchaseOrder} disabled={props.qboActive}>
                            <OwLabel title={"email_purchase_order"} />
                        </Dropdown.Item>
                        <Dropdown.Item onClick={props.callbacks.deleteQboPurchaseOrder} disabled={props.qboActive}>
                            <OwLabel title={"delete_purchase_order"} />
                        </Dropdown.Item>
                    </>
                ) : (
                    <Dropdown.Item onClick={props.callbacks.showCreateQboPurchaseOrderSidebar} disabled={props.qboActive}>
                        <OwLabel title={"create_purchase_order"} />
                    </Dropdown.Item>
                )}
            </Dropdown.Menu>
        </Dropdown>
    );

    return (
        <div className={"OtherPurchaseOrderButtons"}>
            <ControlBar name={"Other Purchase Order Buttons"} sections={[{ name: "QBO Actions", elements: [qboDropdown] }]} />
        </div>
    );
};
